import { useEffect, useState } from "react";
import { HeartCrack, Loader2, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

const fmt = (s) => new Date(s).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const Counts = ({ d }) => (
  <div className="space-y-2" data-testid="farewells-counts">
    {d.counts.map(([r, n]) => (
      <div key={r} className="space-y-1">
        <div className="flex justify-between text-sm"><span className="font-semibold">{r}</span><b className="tabular-nums">{n}</b></div>
        <div className="h-2 rounded-full bg-rose-50 overflow-hidden"><div className="h-full pink-gradient rounded-full" style={{ width: `${(n / d.counts[0][1]) * 100}%` }} /></div>
      </div>
    ))}
  </div>
);

export function FarewellsAdmin() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/farewells").then(({ data }) => setD(data)).catch((e) => toast.error(formatErr(e))); }, []);
  if (!d) return <Loader2 className="w-6 h-6 animate-spin text-rose-400 mx-auto" />;
  return (
    <div className="rounded-3xl bg-white border border-pink-100 p-5 space-y-5" data-testid="farewells-admin">
      <div>
        <h2 className="text-lg font-extrabold flex items-center gap-2"><HeartCrack className="w-5 h-5 text-rose-500" /> Abschiede – warum Mitglieder gehen</h2>
        <p className="text-sm text-slate-500">Freiwillige Antworten beim Löschen des Kontos. <b data-testid="farewells-total">{d.total}</b> Antworten, davon <b>{d.restored}</b> zurückgekommen.</p>
      </div>
      {d.total === 0 ? <p className="text-sm text-slate-400 text-center py-6" data-testid="farewells-empty">Noch niemand hat beim Löschen einen Grund angegeben 💖</p> : (
        <>
          {d.counts.length > 0 && <Counts d={d} />}
          <ul className="divide-y divide-pink-50" data-testid="farewells-list">
            {d.items.map((f) => (
              <li key={f.id} className="py-3 space-y-1" data-testid={`farewell-${f.id}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="text-sm font-bold truncate">{f.name || "Mitglied"} <span className="font-normal text-slate-400">· {f.email}</span></p>
                  <span className="text-xs text-slate-400 shrink-0">{fmt(f.created_at)}</span>
                </div>
                {f.reason && <span className="inline-block px-2.5 py-0.5 rounded-full bg-rose-50 text-rose-600 text-xs font-bold">{f.reason}</span>}
                {f.restored && <span className="inline-flex items-center gap-1 ml-1.5 px-2.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 text-xs font-bold"><RotateCcw className="w-3 h-3" /> Zurückgekommen</span>}
                {f.note && <p className="text-sm text-slate-600 italic">„{f.note}“</p>}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
